import store from 'store'
import actions from './actions'

const initialState = {
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    authorized: process.env.REACT_APP_AUTHENTICATED || false, // false is default value
    loading: false,
    // Seeded from storage so a page reload keeps a restricted session on the
    // forced-change screen instead of dropping it into the app shell.
    passwordChangeRequired: store.get('pwdChangeRequired') === true,
    passwordChangeError: '',
    username: store.get('username') || ''
}

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_STATE:
            return {...state, ...action.payload}
        default:
            return state
    }
}
